import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { IdGeneratorService } from 'src/common/services/id-generator.service';
import { ArticleType, ArticleTypeAttribute, ArticleTypeAttributeType, ArticleTypeCalculationMethod, ArticleTypeCalculationPrecission, ArticleTypeCalculationRuleAttribute } from '../../article-type.model';

@Component({
  selector: 'app-article-type-calculation-rule-editor',
  templateUrl: './article-type-calculation-rule-editor.component.html',
  styleUrls: ['./article-type-calculation-rule-editor.component.scss']
})
export class ArticleTypeCalculationRuleEditorComponent implements OnInit {

  formGroup = new FormGroup({});

  confirmDisabled = false;

  calculationRuleAttribute: ArticleTypeCalculationRuleAttribute;
  originalCalculationRuleAttribute: ArticleTypeCalculationRuleAttribute;

  precissions = [ArticleTypeCalculationPrecission.DECIMAL, ArticleTypeCalculationPrecission.NUMBER, ArticleTypeCalculationPrecission.ATTRIBUTE];
  methods = [ArticleTypeCalculationMethod.ADD, ArticleTypeCalculationMethod.SUBTRACT];

  articleType: ArticleType;

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<ArticleTypeCalculationRuleEditorComponent>,
    private idGenerator: IdGeneratorService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.articleType = data.articleType;
    if (data.calculationRuleAttribute != null) {
      this.calculationRuleAttribute = new ArticleTypeCalculationRuleAttribute(data.calculationRuleAttribute);
      this.originalCalculationRuleAttribute = data.calculationRuleAttribute;
    } else {
      this.calculationRuleAttribute = new ArticleTypeCalculationRuleAttribute({ id : idGenerator.getNextId()});
    }

    this.formGroup.addControl('precission', new FormControl(false, [Validators.required]));
    this.formGroup.addControl('attributeSelection', new FormControl(this.getAttributesForSelection(), []));
    this.formGroup.addControl('method', new FormControl(false, [Validators.required]));
    this.formGroup.addControl('sortValue', new FormControl('', []));
    // this.formGroup.addControl('calculationIndex', new FormControl(false, []));

    this.formGroup.patchValue({
      precission: this.calculationRuleAttribute.precission,
      method: this.calculationRuleAttribute.method,
      attributeSelection: this.calculationRuleAttribute.attributeId,
      sortValue: this.calculationRuleAttribute.sortValue
    });

    this.checkAndSetAttributeSelectionEnablement();

    this.formGroup.valueChanges.subscribe(values => {
      this.calculationRuleAttribute.precission = values.precission;
      this.calculationRuleAttribute.method = values.method;
      this.calculationRuleAttribute.calculationIndex = 0;
      this.calculationRuleAttribute.attributeId = values.attributeSelection;
      this.calculationRuleAttribute.sortValue = values.sortValue;
      this.checkAndSetAttributeSelectionEnablement();
    });

    this.formGroup.statusChanges.subscribe(newStatus => {
      console.log('statusChanges', newStatus, this.formGroup);
      this.confirmDisabled = !this.checkCalculationRuleValid();
    });

    this.confirmDisabled = !this.checkCalculationRuleValid();
  }

  ngOnInit(): void {
    this.formGroup.markAllAsTouched();
  }

  public onNameChanged(dictionary: DictionaryEntry) {
    this.calculationRuleAttribute.name = new DictionaryEntry(dictionary);
    this.confirmDisabled = !this.checkCalculationRuleValid();
    console.log('CalcRule: onNameChanged', dictionary, this.confirmDisabled);
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {

    console.log(this.articleType);

    if (this.articleType != null && this.originalCalculationRuleAttribute == null) {
      this.articleType.calculationRules.push(this.calculationRuleAttribute);
    } else {
      this.originalCalculationRuleAttribute.copyValues(this.calculationRuleAttribute);
    }

    this.dialogRef.close(true);
  }

  getAttributesForSelection(): Array<ArticleTypeAttribute> {
    const attributes = new Array<ArticleTypeAttribute>();
    this.articleType?.attributeGroups.forEach(elm => {elm.attributes?.forEach(a => {
      if (a.type === ArticleTypeAttributeType.NUMBER || a.type === ArticleTypeAttributeType.DECIMAL) {
        attributes.push(a);
      }
    })});
    return attributes;
  }

  private checkAndSetAttributeSelectionEnablement() {
    if (this.calculationRuleAttribute.precission == null || this.calculationRuleAttribute.precission !== ArticleTypeCalculationPrecission.ATTRIBUTE) {
      this.formGroup.controls.attributeSelection.disable({onlySelf: true});
    } else {
      this.formGroup.controls.attributeSelection.enable({onlySelf: true});
    }
  }

  private checkCalculationRuleValid(): boolean {
    return this.formGroup.valid
            && this.calculationRuleAttribute.name != null
            && this.calculationRuleAttribute.name.checkValueExistsForLanguage('de');
  }
}
